module.exports = __webpack_public_path__ + "static/media/galacticzoo.6787ecff.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/galacticzoo.png
 ** module id = 289
 ** module chunks = 0
 **/